import React from 'react';
import { classNames } from 'utils/globals/helpers';

export interface IListItem {
  children: JSX.Element;
  spacing: number;
  className?: string;
}

export const ListItem: React.FC<IListItem> = ({
  className,
  children,
  spacing,
}) => <li className={`w-full ${spacing} ${className}`}>{children}</li>;
